import React, { useState, useEffect, useContext } from 'react';
import axios from '../../axios'; // Adjust the import based on your file structure
import Select, { components } from 'react-select';
import AuthContext from '../../AuthContext';
import PropTypes from 'prop-types';

// Custom menu component without infinite scrolling
const CustomMenuList = (props) => {
  const { children } = props;

  return (
    <components.MenuList {...props} className="custom-menu-list">
      {children} {/* Render all children */}
    </components.MenuList>
  );
};

// Component to handle multi-select course dropdown
const MultiSelectCourseDropdown = ({ selectedCourses = [], onChange, isDisabled, imp }) => {
  const [courses, setCourses] = useState([]);
  const [error, setError] = useState(null);
  const { centre } = useContext(AuthContext);

  // Fetch courses from the API
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get('/all_sectors/getall_sectors');
        setCourses(response.data);
      } catch (error) {
        setError('Error fetching sectors.');
      }
    };

    fetchCourses();
  }, [centre]);

  // Transform course data for react-select
  const options = courses.map(course => ({
    value: course.sector_name,
    label: course.sector_name,
  }));

  // Handle change event from react-select
  const handleChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    onChange(selectedValues);
  };

  return (
    <div>
      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        Sectors Name {imp && <span className="text-red-500">*</span>}
      </label>
      <Select
        isMulti
        options={options}
        value={options.filter(option => selectedCourses && selectedCourses.includes(option.value))}
        onChange={handleChange}
        isDisabled={isDisabled}
        className={`basic-single ${error ? 'border-red-600' : ''}`}
        classNamePrefix="Select"
        components={{ MenuList: CustomMenuList }}
      />
      {error && <p className="text-red-500">{error}</p>}
      <style jsx>{`
        .custom-menu-list {
          max-height: 150px;
          overflow-y: auto; /* Show scrollbar when needed */
          border: 1px solid skyblue;
          padding: 4px;
        }
      `}</style>
    </div>
  );
};

// PropTypes for type validation
MultiSelectCourseDropdown.propTypes = {
  selectedCourses: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

export default MultiSelectCourseDropdown;
